import { render, staticRenderFns } from "./PersonalBranchesPanel.vue?vue&type=template&id=4b7fb524"
import script from "./PersonalBranchesPanel.vue?vue&type=script&lang=js"
export * from "./PersonalBranchesPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports